let token = "";
let resetHandler = null;

export function setTurnstileToken(value) {
  token = typeof value === "string" ? value : "";
}

export function getTurnstileToken() {
  return token;
}

export function registerTurnstileReset(handler) {
  resetHandler = typeof handler === "function" ? handler : null;

  return () => {
    if (resetHandler === handler) resetHandler = null;
  };
}

export function resetTurnstileToken() {
  token = "";
  if (resetHandler) resetHandler();
}
